/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class ConfigurationFileUpload implements IDirective {
        public controller = ['$scope', 'fileUploadDownloadService', ConfigurationFileUploadController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/configurationFileUpload.html';
        public restrict: string = "E";

        public scope: any = {
            model: "=",
            documents: "=",
            documentsAllowed: "=",
            hideUpload: "="
        };

        public link(scope: IConfigurationFileUploadScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            controller: ConfigurationFileUploadController): void {
        }
    }

    export interface IConfigurationFileUploadScope extends ng.IScope {
        model: models.FileUploadModel;
        documents: Wars.Domain.Model.Dtos.DocumentDto[];
        uploadFiles(files: any): void;
        getFaClass(filename: string): string;
        acceptsText: string;
    }

    export class ConfigurationFileUploadController implements IController {
        private scope: IConfigurationFileUploadScope;
        private fileUploadDownloadService: services.FileUploadDownloadService;

        constructor($scope: IConfigurationFileUploadScope, fileUploadDownloadService: services.FileUploadDownloadService) {
            this.scope = $scope;
            this.scope.uploadFiles = (files: any) => this.uploadFiles(files);
            this.fileUploadDownloadService = fileUploadDownloadService;
            this.scope.acceptsText = ".gif,.jpeg,.jpg,.jpe,.tiff,.tif,.pdf,.doc,.docx,.xls,.xlsx,.txt,.dwg";
        }

        private uploadFiles(files) {

            if (this.scope.model.processConfigId) {
                this.fileUploadDownloadService.uploadProcessLevelStaticFiles(files, this.scope.model).then((documentDtos) => { this.uploadCallback(documentDtos); });
            }
            else if (this.scope.model.systemLevelId) {
                this.fileUploadDownloadService.uploadSystemLevelStaticFiles(files, this.scope.model).then((documentDtos) => { this.uploadCallback(documentDtos); });
            } else {
                this.fileUploadDownloadService.uploadProcessLevelStaticFiles(files, this.scope.model).then((documentDtos) => { this.uploadCallback(documentDtos); });
            }
        }

        private uploadCallback(documentDtos: Wars.Domain.Model.Dtos.DocumentDto[]): void {
            if (documentDtos) {
                for (var i= 0; i < documentDtos.length; i++)
                {
                    this.scope.documents.push(documentDtos[i]);
                }
            }
        }
    }
}

warsApp.registerDirective('ConfigurationFileUpload', []);